import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const CreateModal = ({ toggleModal }) => {
  const mahasiswaOption = [
    { value: "Muhammad Rafi Nugraha", label: "Muhammad Rafi Nugraha" },
    { value: "Zami Betawi", label: "Zami Betawi" },
  ];

  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Tambah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Nama</label>
          <Select options={mahasiswaOption} />
        </div>

        <div className="form-group mb-3">
          <label className="form-label">Waktu Hadir</label>
          <input type="time" className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Keterangan</label>
          <textarea className="form-control" />
        </div>
        <button className="btn w-100 btn-success" onClick={closeModal}>
          Tambah
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default CreateModal;
